module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data03-sp-91d34265ce82626fb4c938fe3e849c33.png";